import { Helmet } from 'react-helmet-async';
import { ORG_JSON_LD } from '@/config/org';

/**
 * Site-wide Organization (NGO) schema. Injected once via Layout. Federal
 * contracting officers and foundation reviewers parse JSON-LD; missing or
 * malformed schema is a credibility flag during due diligence.
 *
 * Validates at https://validator.schema.org/
 */
export default function SiteJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(ORG_JSON_LD)}
      </script>
    </Helmet>
  );
}
